import styled from 'styled-components';
import { theme } from '../../../constants/theme.mjs';
import '../../Button/index.mjs';
import { Button } from '../../Button/Button.mjs';
"use strict";
const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  row-gap: 16px;
`;
const CustomLinkButton = styled(Button)`
  line-height: 1;
  display: flex;
  align-items: center;
  min-height: auto;
  color: ${theme.colors.menu.text.light};
  width: 100%;

  &:hover {
    color: ${theme.colors.black50};
  }

  ${({
  $active
}) => $active && `
      color: ${theme.colors.primaryBlue};
  `}
`;
const LanguageKey = styled.div`
  font-variant: all-petite-caps;
  font-weight: 700;
  text-align: left;
  margin-right: 6px;
  align-self: start;
  white-space: nowrap;
`;
const LanguageValue = styled.div`
  font-family: ${theme.fontFamily.default};
`;
const CustomButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({
  $active
}) => $active && `
      color: ${theme.colors.primaryBlue};
  `}
`;
const Frame = styled.div`
  border-radius: 6px;
  padding: 20px;
  background: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export { ButtonWrap, CustomButton, CustomLinkButton, Frame, LanguageKey, LanguageValue };
//# sourceMappingURL=LanguageFrame.styles.mjs.map
